import React from "react";
import "../../styles/dayStyles/Day03.css";

export default function Day03() {
    return (
        <>
            {/* black box container */}
            <div className="day-container container-color3">
            
                {/* circle containing image */}
                <div className="day3-circle">
                    <div className="sun" />
                    <div className="pyramid" />
                    <div className="shadow" />
                </div>
            </div>
        </>
    )
}
